import { atom } from 'recoil'

export const isSearchBoxOpenAtom = atom<boolean>({
    key: 'isSearchBoxOpenAtom',
    default: false,
})
